<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.guardTourReports') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-shield"></i>
          <span>{{ $ml.get('shared.guardTourSystem') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.guardTourReports') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row" style="margin-bottom:10px;">
        <div class="col-sm-4">
          <div class="input-group">
            <label v-show="checkedGuardList != ''" class="form-control tdb-box">{{ checkedGuardList }}</label>
            <label v-show="checkedGuardList == ''" class="form-control">{{ $ml.get('general.notSelected') }}</label>
            <div class="input-group-btn">
              <button data-toggle="modal" data-target="#modal-select-guard" class="btn btn-primary">
                <i class="fa fa-search"></i>
              </button>
              <button v-show="checkedGuardList != ''" class="btn btn-danger" @click="clearCheckedGuards()">
                <i class="fa fa-remove"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="input-group">
            <input type="datetime-local" v-model="startDate" class="form-control" />
            <span class="input-group-addon">-</span>
            <input type="datetime-local" v-model="endDate" class="form-control" />
            <span class="input-group-btn">
              <button @click="send()" type="button" class="btn btn-primary " style="width:100%;">
                <i class="fa fa-search"></i>
                {{ $ml.get('general.view') }}
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="box box-primary">
            <div class="box-header">
              <i class="fa fa-setting"></i>
              <h3 class="box-title">
                <span>Tur Hareket Raporu</span>
              </h3>
              <div class="pull-right">
                <button v-show="logList.length > 0" @click="exportToPDF()" type="button" class="btn btn-danger btn-sm ">
                  <i class="fa fa-share"></i>
                  {{ $ml.get('general.exportToPdfOrPrint') }}
                </button>
              </div>
            </div>
            <div class="box-body">
              <div id="printReport" v-show="logList.length > 0" class="table-responsive no-padding"
                :style="windowHeightSize">
                <div class="text-center">
                  <span>Tur Hareket Raporu ({{ this.startDate | toDateFormatGet("gg.aa.yyyy ss:dd") }} -
                    {{ this.endDate | toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                </div>
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th class="text-left">Adı</th>
                      <th class="text-left">Kontrol Noktası</th>
                      <th class="text-left">Okutma Zamanı</th>
                      <th class="text-left">Hareket Durumu</th>
                      <th class="text-left">Koordinat</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="log in logList" :key="log.id" class="rows">
                      <td>
                        <span>{{ log.name }}</span>
                      </td>
                      <td>
                        <span>{{ log.controlPoint }}</span>
                      </td>
                      <td>
                        <span>{{ log.date }}</span>
                      </td>
                      <td>
                        <span v-show="log.isOnlineRead" class="badge label-success">Çevrim içi</span>
                        <span v-show="!log.isOnlineRead" class="badge label-danger">Çevrim dışı</span>
                      </td>
                      <td>
                        <a v-if="log.location" style="margin-top:10px;" href="#"
                          @click.prevent="openWindow(log)">{{
                            log.location.lat }}
                          - {{ log.location.lon }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="logList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('alerts.recordNotFound') }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
      </div>
      <!--GÖREVLİ SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-guard" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>Görevli Seç</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox no-border" v-show="guardList.length > 0"
                  style="background-color:#f4f4f4;font-weight:bold;">
                  <label style="margin-left:20px;">
                    <input type="checkbox" :checked="checkedGuardCount == guardList.length" @change="
                      guardList.forEach(guard => {
                        guard.isCheck = $event.target.checked;
                      });
                    " />
                    Tümünü Seç
                  </label>
                </span>
                <span class="form-control checkbox no-border" v-for="guard in guardList" :key="guard.id">
                  <label style="margin-left:20px;">
                    <input :checked="guard.isCheck"
                      @change="guard.isCheck == true ? guard.isCheck = false : guard.isCheck = true" type="checkbox" />
                    {{ guard.name }}
                    <span v-show="guard.title != ''">( {{ guard.title }} )</span>
                  </label>
                </span>
                <div class="callout callout-warning" v-show="guardList.length == 0">Görevli kaydı bulunamadı...</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- GÖREVLİ SEÇ MODAL END -->
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      startDate: null,
      endDate: null,
      guards: [],
      logs: []
    };
  },
  filters: {
    toDateFormatGet(str) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika =
        str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
    }
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    guardList() {
      return this.guards;
    },
    logList() {
      return this.logs;
    },
    checkedGuardCount() {
      var count = 0;
      this.guardList.forEach(a => {
        if (a.isCheck == true) {
          count += 1;
        }
      });
      return count;
    },
    checkedGuardList() {
      var checkedList = "";
      var list = this.guardList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    openWindow(log) {
      var url = 'http://maps.google.com/maps?f=q&hl=en&q=' + log.location.lat + '+N,+' + log.location.lon + '+E&ie=UTF8&t=k&om=0&ll=' + log.location.lat + ',' + log.location.lon + '&spn=0.003022,0.004989&t=k';
      window.open(
        url,
        '_blank',
        'width=1200,height=800,resizable=yes,scrollbars=yes'
      )
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    async clearCheckedGuards() {
      this.guards = [];
      await this.guardList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getSelectedGuardList() {
      let aList = this.guards;
      let selectedGuards = aList.filter(function (guard) {
        return guard.isCheck == true;
      });
      let selectedGuardList = [];
      await selectedGuards.forEach(guard => {
        selectedGuardList.push(guard.id);
      });
      return selectedGuardList;
    },
    async send() {
      if ((this.startDate == null) | (this.endDate == null)) {
        alertify.warning(this.$ml.get("alerts.pleaseCheckEnteredValue"));
        return;
      }
      try {
        this.isLoading = true;
        const logs = [];
        let selectedUser = await this.getSelectedGuardList();
        var startDate = this.startDate;
        var endDate = this.endDate;
        const response = await this.$axios
          .post("/Reports/GuardMovementReport", {
            empIds: selectedUser,
            startDate: startDate,
            endDate: endDate
          })
          .then(response => {
            response.data.datas.forEach(doc => {
              doc.veriler.forEach(satir => {
                logs.push({
                  name: satir.name,
                  controlPoint: satir.controlPoint,
                  date: satir.date,
                  location: satir.location,
                  isOnlineRead: satir.isOnlineRead
                });
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.logs = logs;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getGuards() {
      try {
        this.isLoading = true;
        const guards = [];
        const response = await this.$axios
          .get("/GuardDefinition")
          .then(response => {
            response.data.forEach(doc => {
              guards.push({
                id: doc.id,
                name: doc.name,
                title: doc.title,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.guards = guards;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getGuards();
    await this.getDefaultDate();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/guardTour/GuardTourReports.vue